"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ProviderCardEmpty = function ProviderCardEmpty() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "ui-provider-card"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "ui-provider-card__info"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "ui-provider-card__detail"
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: "ui-provider-card__name"
  }, "No matches"), /*#__PURE__*/_react["default"].createElement("p", {
    className: "ui-provider-card__message"
  }, "There are no organizations which match your criteria"))));
};
var _default = exports["default"] = ProviderCardEmpty;